import { useState } from 'react';
import { Publish } from '@material-ui/icons';
import SweetAlert from 'react-bootstrap-sweetalert';
import sweetAlertStyle from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import { Trans, useTranslation } from 'react-i18next';
import { RadioGroup } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import LabeledRadio from 'components/LabeledRadio/LabeledRadio';
import { grayColor } from 'assets/jss/material-dashboard-pro-react';

const useStyles = makeStyles({
  ...sweetAlertStyle,
  alertContent: {
    textAlign: 'left',
    color: grayColor[16],
  },
  labelRoot: {
    alignItems: 'flex-start',
    margin: '16px 8px 0 0',
  },
  radio: {
    paddingTop: '2px',
  },
  publishIcon: {
    color: '#46ad58',
  },
});

const PublishMenu = ({ menuPlanners, onPublish }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const [
    isOverrideChangedMenuModalVisible,
    setIsOverrideChangedMenuModalVisible,
  ] = useState(false);
  const [overrideChangedMenu, setOverrideChangedMenu] = useState('1');

  const hideAlert = () => {
    setIsConfirmModalVisible(false);
    setIsOverrideChangedMenuModalVisible(false);
  };

  const mapBlockToKey = (el, draft) =>
    `${draft ? 'T' : 'N'}_${el.diet?.['@id'] ?? el.diet}_${
      el.variant?.['@id'] ?? el.variant
    }_${el.mealType?.['@id'] ?? el.mealType}`;

  const containsOverrides = () => {
    const map = menuPlanners
      .filter(el => !el.draft)
      .map(el => mapBlockToKey(el, false));
    return (
      menuPlanners.filter(
        el => el.draft && map.includes(mapBlockToKey(el, false))
      ).length > 0
    );
  };

  return (
    <>
      <BottomNavigationAction
        label={t('menuPlanner.action.plan.publish.actionTitle')}
        showLabel={true}
        icon={<Publish className={classes.publishIcon} />}
        onClick={() => {
          setIsConfirmModalVisible(true);
        }}
      />
      {isConfirmModalVisible && (
        <SweetAlert
          warning={true}
          title={t('menuPlanner.action.plan.publish.alertTitle')}
          onConfirm={() => {
            if (containsOverrides()) {
              setIsOverrideChangedMenuModalVisible(true);
              setIsConfirmModalVisible(false);
            } else {
              onPublish(false);
              hideAlert();
            }
          }}
          onCancel={hideAlert}
          confirmBtnCssClass={`${classes.button} ${classes.success}`}
          cancelBtnCssClass={`${classes.button}`}
          confirmBtnText={t('menuPlanner.action.plan.publish.actionTitle')}
          cancelBtnText={t('common.cancel')}
          showCancel={true}
        >
          {t('menuPlanner.action.plan.publish.alertDescription')}
        </SweetAlert>
      )}
      {isOverrideChangedMenuModalVisible && (
        <SweetAlert
          warning={true}
          title={t('menuPlanner.action.plan.publish.overrideChangedMenu.title')}
          onConfirm={() => {
            const parsedValue = overrideChangedMenu === '1';

            onPublish(parsedValue);
            hideAlert();
          }}
          onCancel={() => {
            hideAlert();
          }}
          confirmBtnCssClass={`${classes.button} ${classes.success}`}
          cancelBtnCssClass={`${classes.button}`}
          confirmBtnText={t('common.apply')}
          cancelBtnText={t('menuPlanner.action.plan.publish.cancel')}
          showCancel={true}
        >
          <RadioGroup
            value={overrideChangedMenu}
            onChange={e => {
              setOverrideChangedMenu(e.target.value);
            }}
          >
            <LabeledRadio
              FormControlLabelProps={{
                classes: {
                  label: classes.alertContent,
                  root: classes.labelRoot,
                },
              }}
              classes={{ root: classes.radio }}
              label={
                <Trans
                  i18nKey="menuPlanner.action.plan.publish.overrideChangedMenu.falseOption"
                  components={{
                    b: <b />,
                    br: <br />,
                  }}
                />
              }
              value="0"
            />
            <LabeledRadio
              FormControlLabelProps={{
                classes: {
                  label: classes.alertContent,
                  root: classes.labelRoot,
                },
              }}
              classes={{ root: classes.radio }}
              label={
                <Trans
                  i18nKey="menuPlanner.action.plan.publish.overrideChangedMenu.trueOption"
                  components={{
                    b: <b />,
                    br: <br />,
                  }}
                />
              }
              value="1"
            />
          </RadioGroup>
        </SweetAlert>
      )}
    </>
  );
};

export default PublishMenu;
